import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { getApiEndpoint } from '../../../config/api';

const CRADLE_TYPES = [
  'Fixed Roof-Mounted Cradle', 'Mobile Roof-Mounted Cradle', 'Ground-Based Cradle',
  'Monorail Cradle', 'Building Maintenance Unit (BMU)', 'Davits with Suspended Cradle', 'Portable/Temporary Cradle'
];

export default function EditCradleModal({ isOpen, onClose, cradle, onSuccess }) {
  const [formData, setFormData] = useState({
    cradle_name: '', location: '', type: '', last_inspection_date: '', last_load_test_date: '', notes: ''
  });

  useEffect(() => {
    if (cradle) {
      setFormData({
        cradle_name: cradle.cradle_name || '',
        location: cradle.location || '',
        type: cradle.type || '',
        last_inspection_date: cradle.last_inspection_date ? new Date(cradle.last_inspection_date).toISOString().split('T')[0] : '',
        last_load_test_date: cradle.last_load_test_date ? new Date(cradle.last_load_test_date).toISOString().split('T')[0] : '',
        notes: cradle.notes || ''
      });
    }
  }, [cradle]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(getApiEndpoint(`/api/properties/${cradle.property_id}/cradles/${cradle.id}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(formData)
      });
      if (!response.ok) throw new Error('Failed to update cradle');
      const updated = await response.json();
      onSuccess(updated);
      onClose();
      toast.success('Cradle updated successfully');
    } catch (err) {
      console.error('Error updating cradle:', err);
      toast.error(err.message);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this cradle?')) return;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(getApiEndpoint(`/api/properties/${cradle.property_id}/cradles/${cradle.id}`), {
        method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to delete cradle');
      onSuccess({ ...cradle, deleted: true });
      onClose();
      toast.success('Cradle deleted successfully');
    } catch (err) { toast.error(err.message); }
  };

  if (!isOpen || !cradle) return null;

  return (
    <div className="rs-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="rs-modal" role="dialog" aria-modal="true" aria-labelledby="edit-cradle-title">
        <div className="rs-modal-header">
          <h2 id="edit-cradle-title">Edit Cradle</h2>
          <button className="rs-modal-close" onClick={onClose} aria-label="Close modal"><FontAwesomeIcon icon={faTimes} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="rs-modal-body">
            <div className="rs-form-grid">
              <div className="rs-form-group">
                <label htmlFor="edit-cradle-id">ID *</label>
                <input id="edit-cradle-id" type="text" value={formData.cradle_name} onChange={e => setFormData({ ...formData, cradle_name: e.target.value })} required />
              </div>
              <div className="rs-form-group">
                <label htmlFor="edit-cradle-type">Type *</label>
                <select id="edit-cradle-type" value={formData.type} onChange={e => setFormData({ ...formData, type: e.target.value })} required>
                  {CRADLE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div className="rs-form-group rs-full-width">
                <label htmlFor="edit-cradle-location">Location *</label>
                <input id="edit-cradle-location" type="text" value={formData.location} onChange={e => setFormData({ ...formData, location: e.target.value })} required />
              </div>
              <div className="rs-form-group">
                <label htmlFor="edit-cradle-last-date">Last Inspection Date</label>
                <input id="edit-cradle-last-date" type="date" value={formData.last_inspection_date} onChange={e => setFormData({ ...formData, last_inspection_date: e.target.value })} />
              </div>
              <div className="rs-form-group">
                <label htmlFor="edit-cradle-load-date">Last Load Test Date</label>
                <input id="edit-cradle-load-date" type="date" value={formData.last_load_test_date} onChange={e => setFormData({ ...formData, last_load_test_date: e.target.value })} />
              </div>
              <div className="rs-form-group rs-full-width">
                <label htmlFor="edit-cradle-notes">Notes</label>
                <textarea id="edit-cradle-notes" value={formData.notes} onChange={e => setFormData({ ...formData, notes: e.target.value })} rows="3" />
              </div>
            </div>
          </div>
          <div className="rs-modal-footer">
            <button type="button" className="rs-btn rs-btn-danger" onClick={handleDelete}>Delete</button>
            <button type="button" className="rs-btn rs-btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="rs-btn rs-btn-primary">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}
